import common from "@/assets/js/common";
import Vue from 'vue';
const vm = new Vue();
let abortController = new AbortController();

export async function fetchSSE(url, data, onDataReceived) {
    
    abortController = new AbortController()
    // abortController.abort()
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer " +  common.getCookie("token"),
            'Accept': 'text/event-stream',
            "signal": abortController.signal // 告诉服务器你想要 SSE
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        vm.$msg({
            message: response.statusText,
            type: "error",
            showClose: true,
            duration: 2 * 1000
        })
        onDataReceived('request_error');
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    // 使用 ReadableStream 读取流式数据
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    while (true) {
        const { done, value } = await reader.read();
        if (done || abortController.signal.aborted) break;
        const chunk = decoder.decode(value, { stream: true });
        onDataReceived(chunk) 
    }
}
export function stopFetchSSE() {
    abortController.abort()
}
